import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, Heart, Gift, EyeOff, Eye, Calendar, Radio, HeartHandshake, Smartphone } from "lucide-react";
import api from "@/lib/api";
import { useFeature } from "@/contexts/FeaturesContext";

/* ── Portofelul de Semințe (17.12) ── */


/* ── „Reia ce contează" (16.10): lecții terminate acum 7+ zile, readuse blând ── */
export function ReviewRow() {
  const enabled = useFeature("review_row");
  const [items, setItems] = useState([]);
  useEffect(() => { if (enabled) api.get("/me/review-lessons").then((r) => setItems(r.data.items || [])).catch(() => {}); }, [enabled]);
  if (!enabled || items.length === 0) return null;
  return (
    <div className="card-premium p-6" data-testid="review-row">
      <h3 className="font-serif text-lg mb-1">Reia ce contează</h3>
      <p className="text-[11px] mb-3" style={{ color: "var(--ct-text-dim)" }}>Lecțiile care te-au ajutat se așază mai adânc la a doua trecere. Fără grabă.</p>
      <div className="space-y-1.5">
        {items.map((l, i) => (
          <Link key={i} to={`/cursuri/${l.course_slug}/invata`} className="flex items-center justify-between gap-3 py-2 px-2 rounded-lg hover:bg-[var(--ct-bg-soft)] transition-colors">
            <div className="min-w-0">
              <p className="text-sm truncate">{l.lesson_title}</p>
              <p className="text-[10px]" style={{ color: "var(--ct-text-dim)" }}>{l.course_title} · văzută acum {l.days_ago} zile</p>
            </div>
            <Radio size={14} className="shrink-0" style={{ color: "var(--ct-gold)" }} />
          </Link>
        ))}
      </div>
    </div>
  );
}
